import { render, staticRenderFns } from "./skeletonNav2.vue?vue&type=template&id=7c00d0ea&scoped=true"
var script = {}
import style0 from "./skeletonNav2.vue?vue&type=style&index=0&id=7c00d0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00d0ea",
  null
  
)

export default component.exports